import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { TenantLocationSwitchService } from '@core/tenant/tenant-location-switch.service';

@Component({
  selector: 'app-location-switcher',
  imports: [MaterialModule, TablerIconsModule, TranslateModule],
  templateUrl: './location-switcher.component.html',
  styleUrl: './location-switcher.component.scss',
  host: { class: 'location-switcher-host shrink-0' },
})
export class LocationSwitcherComponent {
  readonly switchService = inject(TenantLocationSwitchService);

  selectLocation(locationId: number): void {
    this.switchService.switchLocation(locationId);
  }
}
